import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import transporterService from '../services/transporter.service';


export const fetchTransporterList = createAsyncThunk(
    'transporter/fetchTransporterList',
    async ({ page, pagesize, search, ordering, signal, requestId }, thunkAPI) => {
        try {
            const response = await transporterService.getTransporterList(page, pagesize, search, ordering, signal);
            return { ...response.data, requestId };
        } catch (error) {
            if (error.name === 'CanceledError') {
                return thunkAPI.rejectWithValue('aborted');
            }
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchArchivedTransporterlist = createAsyncThunk(
    'transporter/fetchArchiveTransporterList',
    async ({ page, pagesize, search, ordering,signal}, thunkAPI) => {
        try {
            const response = await transporterService.getArchiveTransporterList(page, pagesize, search, ordering,signal);
            return response.data;
        } catch (error) {
            if (error.name === 'CanceledError') {
             
                return thunkAPI.rejectWithValue('aborted');
              }
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchTransporterDetails = createAsyncThunk(
    'transporter/fetchTransporterDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await transporterService.getTransporterDetails(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchTransporterById = createAsyncThunk(
    'transporter/fetchTransporterById',
    async (transporterId, { rejectWithValue }) => {
        try {
            const response = await transporterService.getTransporterById(transporterId);
         
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const createTransporter = createAsyncThunk(
    'transporter/createTransporter',
    async ({ values }, thunkAPI) => {
        try {
            const textPayload = {
                party_name: values.party_name,
                party_code: values.party_code,
                opening_balance: values.opening_balance,
                balance_type: values.balance_type,
                is_cash_amount: values.is_cash_amount || false,
                address: values.address,
                city: values.city,
                pincode: values.pincode,
                mobile_no_sms: values.mobile_no_sms,
                mobile_no: values.mobile_no,
                phone_no: values.phone_no,
                email_id: values.email_id,
                send_sms_type:values.send_sms_type,
                is_active: values.is_active || false,
              };
              
            const response = await transporterService.addTransporter(textPayload);
            return response.data; // Assuming response contains the created transporter data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateTransporter = createAsyncThunk(
    'transporter/updateTransporter',
    async ({ id, values }, thunkAPI) => {
        try {
            const formPayload = {
                party_name: values.party_name,
                party_code: values.party_code,
                opening_balance: values.opening_balance,
                balance_type: values.balance_type,
                is_cash_amount: values.is_cash_amount || false,
                address: values.address,
                city: values.city,
                pincode: values.pincode,
                mobile_no_sms: values.mobile_no_sms,
                mobile_no: values.mobile_no,
                phone_no: values.phone_no,
                email_id: values.email_id,
    
                send_sms_type:values.send_sms_type,
                is_active: values.is_active || false,
            };

            const response = await transporterService.updateTransporter(id, formPayload);

            return response.data; // Return the updated transporter data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteTransporter = createAsyncThunk(
    'transporter/deleteTransporter',
    async (id, thunkAPI) => {
        try {
            await transporterService.deleteTransporter(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveTransporter = createAsyncThunk(
    'transporter/unArchiveTransporter',
    async (id, thunkAPI) => {
        try {
            await transporterService.unArchiveTransporterRecord(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    toolsList: [],
    loading: false,
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
    latestRequestId: 0,
};


const transporterSlice = createSlice({
    name: 'transporter',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetTransporterData: (state) => {
            state.data = []; // This will clear the list
        },
        resetTransporterList: (state) => {
            state.list = []; // This will clear the list
        },
        // resetToolsList: (state) => {
        //     state.toolsList = []; // This will clear the list
        // },
        resetCurrentTransporterPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchTransporterList.pending, (state, action) => {
                state.status = 'pending';
                state.loading = true;
                state.latestRequestId = action.meta.arg.requestId;
            })
            .addCase(fetchTransporterList.fulfilled, (state, action) => {
                if (action.payload.requestId !== state.latestRequestId) return;
                state.status = 'succeeded';
                state.loading = false;
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];
                state.totalPages = action.payload.totalPages;
                state.totalRecord = action.payload.count;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchTransporterList.rejected, (state, action) => {
               
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
                if (action.payload === 'aborted') return;
            });
        builder
            .addCase(fetchArchivedTransporterlist.pending, (state) => {
                state.status = 'pending';
                state.loading = true;
            })
            .addCase(fetchArchivedTransporterlist.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.loading = false;
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedTransporterlist.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchTransporterDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTransporterDetails.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchTransporterDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchTransporterById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTransporterById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchTransporterById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });


        builder
            .addCase(createTransporter.pending, state => {
                state.status = 'loading';
            })
            .addCase(createTransporter.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createTransporter.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateTransporter.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateTransporter.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateTransporter.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteTransporter.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteTransporter.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteTransporter.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveTransporter.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveTransporter.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveTransporter.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetTransporterList, resetTransporterData,  resetCurrentTransporterPage } = transporterSlice.actions;
const { reducer } = transporterSlice;
export default reducer;
